import { Injectable, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { OperationObserverService } from '@x/common/operation';
import {
  CheckoutDeleteOrderItem,
  CheckoutUpdateOrderItem,
} from '@x/ecommerce-shop/app/checkout/state/checkout-order.actions';
import {
  OrderDeleteCartItem,
  OrderUpdateCartItem,
} from '@x/ecommerce-shop/app/core/order/state/shop-order.actions';
import { Subscription, of, switchMap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class OrderSummaryService implements OnDestroy {
  private subscription = new Subscription();

  actionQ$ = this.operation.createQueue();

  get isCheckout() {
    return this.router.url.includes('checkout/');
  }

  constructor(
    private operation: OperationObserverService,
    private store: Store,
    private router: Router,
  ) {
    this.subscription.add(this.actionQ$.observe().subscribe());
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  removeItem$(productVariantId: number) {
    return this.actionQ$.queue(
      of('delete').pipe(
        switchMap(() => {
          if (this.isCheckout) {
            return this.store.dispatch(new CheckoutDeleteOrderItem({ productVariantId }));
          }

          return this.store.dispatch(new OrderDeleteCartItem({ productVariantId }));
        }),
      ),
    );
  }

  updateQuantity$(quantity: number, productVariantId: number) {
    return this.actionQ$.queue(
      of('update').pipe(
        switchMap(() => {
          if (this.isCheckout) {
            return this.store.dispatch(new CheckoutUpdateOrderItem({ quantity, productVariantId }));
          }

          return this.store.dispatch(
            new OrderUpdateCartItem({ quantity, productVariantId }, false),
          );
        }),
      ),
    );
  }
}
